import { useEffect, useState } from 'react'

export const useCountUp = (startValue: number, increment = 1, period = 1) => {
	const [count, setCount] = useState(startValue)

	useEffect(() => {
		const interval = setInterval(() => {
			setCount((prev) => prev + increment)
		}, period * 1000)
		return () => clearInterval(interval)
	}, [increment, period])

	return count
}
